const DEFAULT_EDIT_TEMPLATE_ERROR = 'An error occured while updating the calculation template. Please check that you are using a valid excel file.';

function getGraphQLErrorMessage(error) {
  if (!error) {
    return undefined;
  }

  if (error.extensions?.response?.body?.message) {
    return error.extensions.response.body.message;
  }

  return error.message;
}

function getQueryErrorFromError(error) {
  if (error?.graphQLErrors?.length > 0) {
    const graphQLError = Array.isArray(error.graphQLErrors)
      ? error.graphQLErrors[0]
      : error.graphQLErrors;

    return getGraphQLErrorMessage(graphQLError);
  }

  return error.message;
}

function getCheckCalculationTemplateError(results) {
  if (!results.data?.checkCalculationTemplate?.status) {
    return results.data?.checkCalculationTemplate?.message;
  }

  return undefined;
}

function getEditCalculationTemplateResponseError(results) {
  const editCalculationTemplateResponse = results.data?.editCalculationTemplate;

  if (editCalculationTemplateResponse?.status !== false) {
    return undefined;
  }

  if (editCalculationTemplateResponse.message) {
    return editCalculationTemplateResponse.message;
  }

  if (editCalculationTemplateResponse.warnings?.length) {
    return editCalculationTemplateResponse.warnings.join('\n');
  }

  return undefined;
}

function getApolloResultErrors(results) {
  const errors = [...(results.errors || [])];
  if (results.error) {
    errors.push(results.error);
  }

  if (errors.length === 0) {
    return undefined;
  }

  let error = Array.isArray(errors) ? errors[0] : errors;

  if (error?.graphQLErrors) {
    error = Array.isArray(error.graphQLErrors) ? error.graphQLErrors[0] : error.graphQLErrors;
  }

  return getGraphQLErrorMessage(error);
}

export default function getQueryErrorMessage(results) {
  if (results instanceof Error) {
    return getQueryErrorFromError(results);
  }

  if (typeof results === 'string') {
    return results;
  }

  return getCheckCalculationTemplateError(results)
    || getEditCalculationTemplateResponseError(results)
    || getApolloResultErrors(results);
}

export function getEditCalculationTemplateError(queryResults, fallbackMessage = DEFAULT_EDIT_TEMPLATE_ERROR) {
  if (queryResults?.data?.editCalculationTemplate?.data) {
    return getQueryErrorMessage(queryResults);
  }

  return getQueryErrorMessage(queryResults)
    || queryResults?.data?.editCalculationTemplate?.warnings?.join('\n')
    || fallbackMessage;
}
